import { Outlet } from 'react-router-dom'
import Header from './Header'

/**
 * Main layout wrapper for protected pages
 * Dark mode geek aesthetic - Desktop only
 */
export default function Layout() {
  return (
    <div className="min-h-screen bg-slate-950">
      <Header />
      <main className="px-8 py-8">
        <Outlet />
      </main>
    </div>
  )
}

